<template>
  <div  class="popup"  v-show="versionShow" v-cloak>
          <div class="content" id='backupVersion'>
              <div class="title">
              {{$t('language.cloudBackup.versions')}}
              <div class="icon white-close dialog-close" @click="close()"></div>
              </div>
                       <div v-if="!notRunShow" class="backversion-title">
                            <span class="version-line">{{$t('language.cloudBackup.backupTime')}}</span>
                            <span class="version-line">{{$t('language.cloudBackup.changedFiles')}}</span>
                            <span class="version-right"></span>
                       </div>
                  <div class="backupVersion-body">
                       <div v-show="!notRunShow" class="backversion-line" v-for="(item, index) in versions" :key="index" @mouseleave="hoverIndex=-1" @mouseenter="hoverIndex = index" :class="hoverIndex==index?'version-back':''">
                            <span class="version-line">{{item.createTime|transferForMatTime}}</span>
                            <span class="version-line">{{item.updateInfo.conut}} files,{{item.updateInfo.size|formatLogByte}} in total</span>
                            <span class="version-right" v-if="hoverIndex==index">
                                <button style="margin-top:5Px;" @click="openRestore(item)">{{$t('language.cloudExploer.restore')}}</button>
                                <div class="version-delete-icon" style="float:right;position:relative;top:10Px;cursor:pointer;" @click="deleteVersion(item)"></div>
                            </span>
                       </div>
                       <div v-show="notRunShow" style="position:relative;top:20Px;">
                            {{$t('language.cloudSync.notRun')}}
                       </div>
                 </div>
          </div>
          
  </div>
</template>

<script>

export default {
    data:function(){
         return{
            versionShow:false,
            versions:[],
            backupRoot:'',
            hoverIndex:-1,
            notRunShow:false,
         }
    },
    mounted(){

    },
    components:{
       
    },
    methods:{
        close(){
            this.versionShow=false;
        },
        deleteVersion(item){
             this.$parent.$refs.deleteAttentionDialog.attentionShow=true;
             this.$parent.$refs.deleteAttentionDialog.item=item;
        },
        openRestore(item){
            this.close();
            this.$parent.openBackupRestore(item.createTime);
        }

    }
}
</script>

<style>
#backupVersion{
    width: 600Px;
    height: 380Px;
}
.backupVersion-body{
    width: 100%;
    height: 295Px;
    padding: 5Px 20Px 20Px 20Px;
    box-sizing: border-box;
    color: #6f7886;
    font-size: 14Px;
    float: left;
    overflow: auto;
}
.backupVersion-body::-webkit-scrollbar {
		width: 5px;
		/*no*/
		/*宽度*/
		border-radius: 5px;
		/*no*/
		background-color: #fff;
		/*背景颜色*/
}
.backupVersion-body::-webkit-scrollbar-thumb {
		height: 1px;
		/*no*/
		border-radius: 5px;
		/*no*/
		background-color: #becae4;
	}
.backversion-title{
    padding: 5Px 20Px 20Px 20Px;
    box-sizing: border-box;
}
.backversion-title,.backversion-line{
    width: 100%;
    height: 40Px;
    float: left;
    color: #6f7886;
    font-size: 14Px;
}
.version-line{
    width: 210Px;
    float: left;
    height: 40Px;
    line-height: 40Px;
}
.version-right{
    width: 110Px;
    float: left;
    height: 40Px;
}
.version-back{
    background: #ebf3fe;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/list_versions_popup.vue